import { v4 as uuidv4 } from 'uuid';
import { dispatchAction } from '@ardoq/rxbeach';
import { trackingStarted, spanRecorded, trackingCompleted } from './actions';
import { PrimitiveValue } from './types';

/**
 * Starts tracking the duration of an event.
 *
 * @returns A tracking ID to use with recordSpan() and completeDurationTracking()
 */
export const startDurationTracking = (
  eventName: string,
  metadata?: Record<string, PrimitiveValue>,
  expectedDuration?: number
): string => {
  const id = uuidv4();
  const startTime = performance.now();

  dispatchAction(
    trackingStarted({
      id,
      eventName,
      startTime,
      metadata,
      expectedDuration,
    })
  );

  return id;
};

/**
 * Records an intermediate checkpoint within a tracking session (optional).
 *
 * Use spans to measure specific phases within a longer operation. They record the
 * relative time from tracking start. You can track durations without any spans.
 */
export const recordSpan = (
  trackingId: string,
  spanName: string,
  metadata?: Record<string, PrimitiveValue>
): void => {
  const timestamp = performance.now();

  dispatchAction(
    spanRecorded({
      trackingId,
      spanName,
      timestamp,
      metadata,
    })
  );
};

/**
 * Completes a duration tracking session.
 */
export const completeDurationTracking = (trackingId: string): void => {
  const endTime = performance.now();

  dispatchAction(
    trackingCompleted({
      trackingId,
      endTime,
    })
  );
};
